export const STORE_MODAL_DESKTOP_WIDTH = 'w-[min(100%,27rem)] max-w-[27rem]';

export const storeModalDesktopIsland = `pointer-events-auto absolute bottom-4 left-4 ${STORE_MODAL_DESKTOP_WIDTH} overflow-hidden rounded-lg border border-N100 bg-white shadow-storeModalIsland`;

export const storeModalMobileSheet = 'pointer-events-auto absolute inset-x-0 bottom-0 w-full overflow-hidden rounded-t-lg bg-white shadow-elevation2';
